import React__default from 'react';
import classNames from 'classnames';
import Styles from './DotSeparated.module.scss.js';

const DotSeparated = ({ nodes, dotStyleClassName, nodesClassName, wrapperClassName }) => {
    return (React__default.createElement("div", { className: classNames(Styles.DotSeparated, wrapperClassName) }, nodes.map((node, idx) => (React__default.createElement("div", { className: classNames(Styles.nodes, nodesClassName), key: idx },
        node,
        " ",
        idx !== nodes.length - 1 ? (React__default.createElement("span", { className: classNames(Styles.dot, dotStyleClassName) })) : (""))))));
};

export { DotSeparated as default };
//# sourceMappingURL=DotSeparated.js.map
